import React from 'react'

import { RecoilRoot } from 'recoil'
import { I18nextProvider } from 'react-i18next'
import { ThemeProvider as ElementsProvider } from 'react-native-elements'
import { ApolloProvider } from '@apollo/client'

import i18n from '../../i18n'
import elementsTheme from '../../themes/elements/theme'
import ThemeProvider from './ThemeProvider'
import API from '../../API'
import CurrentUserController from '../controllers/CurrentUserController'
import FeatureFlagController from '../../featureFlag/FeatureFlagController'

const Providers = ({ children }: any) => {
  return (
    <RecoilRoot>
      <ThemeProvider>
        <ElementsProvider theme={elementsTheme}>
          <I18nextProvider i18n={i18n}>
            <ApolloProvider client={API}>
              <CurrentUserController />
              <FeatureFlagController />
              {children}
            </ApolloProvider>
          </I18nextProvider>
        </ElementsProvider>
      </ThemeProvider>
    </RecoilRoot>
  )
}

export default Providers
